
/**
 * 
 * @export
 * @interface ZiadostBasePredlozenie
 */
export interface ZiadostBasePredlozenie {
    /**
     * 
     * @type {string}
     * @memberof ZiadostBasePredlozenie
     */
    'casOdoslania'?: string;
    /**
     * 
     * @type {string}
     * @memberof ZiadostBasePredlozenie
     */
    'casPrijatia'?: string;
    /**
     * 
     * @type {string}
     * @memberof ZiadostBasePredlozenie
     */
    'sposobPredlozenia'?: ZiadostBasePredlozenieSposobPredlozeniaEnum;
}

export const ZiadostBasePredlozenieSposobPredlozeniaEnum = {
    Listinne: 'LISTINNE',
    Elektronicky: 'ELEKTRONICKY',
    AutorizaciaKlikom: 'AUTORIZACIA_KLIKOM',
    ElektronickyZjednodusene: 'ELEKTRONICKY_ZJEDNODUSENE',
    Neuvedene: 'NEUVEDENE'
} as const;

export type ZiadostBasePredlozenieSposobPredlozeniaEnum = typeof ZiadostBasePredlozenieSposobPredlozeniaEnum[keyof typeof ZiadostBasePredlozenieSposobPredlozeniaEnum];


